import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { PedidoVeiculoService } from 'app/services/pedido-veiculo.service';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class PedidoVeiculosResolver implements Resolve<any> {

    constructor(
        private pedidoVeiculoService: PedidoVeiculoService,
    ) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const codigoPedido = parseInt(route.parent.paramMap.get('id'), 10);
        return this.pedidoVeiculoService.listar(codigoPedido);
    }
}
